import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AuthLayout from 'layout/auth/Auth.layout';
import { useIonViewDidEnter } from '@ionic/react';
import { ForgottenpwdTitle, ForgottenpwdWrapper } from 'pages/forgottenpwd/Forgottenpwd.styled';
import ForgottenpwdEmail from 'pages/forgottenpwd/Forgottenpwd-email';
import ForgottenpwdOptions from 'pages/forgottenpwd/Forgottenpwd-options';
import ForgottenpwdContactTrainer from 'pages/forgottenpwd/Forgottenpwd-contact-trainer';
import ForgottenpwdNewPwd from 'pages/forgottenpwd/Forgottenpwd-newpwd';
import useUpdateChecker from 'hooks/useUpdateChecker';
import useAPIAuth from 'hooks/api/useAPIAuth';
import { ROUTES } from 'constants/routes';
import useFetch from 'hooks/api/useFetch';

export interface ForgottenPwdProps {
  onSubmitted?: (email?: string, hasTrainers?: boolean) => void;
  onBack?: () => void;
  email?: string;
}

const Forgottenpwd: React.FC = () => {
  useUpdateChecker(ROUTES.FORGOTTEN_PWD.INDEX);
  const { t } = useTranslation('translation');
  const { sendForgottenPwdEmail } = useAPIAuth();
  const [email, setEmail] = useState<string>();
  const [step, setStep] = useState(1);
  const [hasTrainers, setHasTrainers] = useState<boolean>(false);
  const { showLoading, hideLoading } = useFetch();

  const onEmailSubmitted = async (e?: string, hasTrainers?: boolean) => {
    if (e) {
      setEmail(e);
      setHasTrainers(hasTrainers || false);

      // Si l'utilisateur a des formateurs, afficher les options (étape 2)
      // Sinon, aller directement à l'étape de nouveau mot de passe (étape 3)
      if (hasTrainers) {
        setStep(2); // Étape des options
      } else {
        setStep(3); // Étape directe vers nouveau mot de passe
      }
    }
  };

  const onEmailOptionSelected = async () => {
    showLoading();
    // Maintenant on envoie l'email quand l'utilisateur choisit l'option email
    try {
      if (email) {
        console.log('Sending forgotten password email to:', email);
        const sentMail = await sendForgottenPwdEmail(email);
        console.log('Forgotten password email sent:', sentMail);
        setStep(3);
      }
    } catch (error) {
      console.error('Error sending forgotten password email:', error);
    } finally {
      hideLoading();
    }
  };

  const onTrainerOptionSelected = () => {
    setStep(4); // Aller à l'étape contact formateur
  };

  useIonViewDidEnter(() => {
    setStep(1);
    setHasTrainers(false);
  });

  return (
    <AuthLayout>
      <ForgottenpwdWrapper className={`step-${step}`}>
        <ForgottenpwdTitle>{t('forgottenpwd.title')}</ForgottenpwdTitle>
        {step === 1 && <ForgottenpwdEmail onSubmitted={onEmailSubmitted} />}
        {step === 2 && hasTrainers && (
          <ForgottenpwdOptions
            onEmailOptionSelected={onEmailOptionSelected}
            onTrainerOptionSelected={onTrainerOptionSelected}
            onBack={() => setStep(1)}
          />
        )}
        {step === 3 && <ForgottenpwdNewPwd email={email} onBack={() => setStep(hasTrainers ? 2 : 1)} />}
        {step === 4 && (
          <ForgottenpwdContactTrainer
            email={email}
            onBack={() => setStep(2)}
          />
        )}
      </ForgottenpwdWrapper>
    </AuthLayout>
  );
};

export default Forgottenpwd;
